// import Backbone from 'backbone';
import {render} from 'preact';
import QtyToggle from '@components/common/QtyToggle';
import User from '@modules/User';
import tmpl from '../../templates';
import namespace from '../../../upi/namespace';
import identity from 'ramda/src/identity';
import memoizeWith from 'ramda/src/memoizeWith';
import {loginButton, viewDistributorsButton} from '@util/HtmlComponents';
import {formatDate} from '@util/DateUtils';
import priceBreakdownModuleView from './priceBreakdownModule';
import {calculateMaxInputQuantityForProduct} from '@modules/products/util';

const app = namespace( 'apps.productpage' );

const stripSpecialCharacters = memoizeWith( identity, function stripSpecialCharacters ( str ) {
    return str.replace( /[\u00AE|\u2122]/gi, '' );
} );

var PriceModuleView = Backbone.View.extend( {

    el: '#skuItemDetails',

    templateSku: _.template( tmpl.priceModuleSku ),
    templateSkuNoCommerce: _.template( tmpl.priceModuleSkuNoCommerce ),
    templateSkuList: _.template( tmpl.priceModuleSkuList ),
    templateskuItemDetails: _.template( tmpl.skuItemDetails ),
    templateEmpty: _.template( tmpl.priceModuleEmpty ),

    // todo: garbage collect views/childViews
    events: {
        'keyup .qty': 'handleQtyChange',
        'change .qty': 'handleQtyChange'
    },

    prevQty: 1,

    initialize: function () {
        this.resetView = this.resetView.bind( this );

        this.priceBreakdownModuleView = new priceBreakdownModuleView();

        this.listenTo( this.collection, 'change reset', this.handleChange );
        this.listenTo( this.priceBreakdownModuleView.collection, 'change:selected', this.handleQuantityBreakChange );
        this.listenTo( app.mediator, 'configuration:select', function ( configuration ) {
            this.configuration = configuration;
        } );

        this.render();
    },

    getQuantity: function () {
        // if value NaN return 1
        const $qtyInput = this.$el.find( '#skuQty' );
        return parseInt( $qtyInput.val(), 10 ) || 1;
    },

    handleChange: async function ( data ) {
        /*
         * if a single Model triggered event, pluck that item from this.SkuList to pass data to 'sku' view
         * else if a Collection render the Range view
         *   if a Collection but only has a single item, pluck that item from this.Skulist and send to 'sku' view
         * else if none of the above default to Empty view
         */
        this.prevQty = 1;
        const isEcommerceSite = app.context.isEcommerceSite;

        if ( data instanceof Backbone.Model ) {

            var sku = data;
            if ( sku.get( 'selected' ) ) {
                var skuData = await this.serializeData( sku );
                var priceModuleTmpl = (isEcommerceSite)
                    ? $( this.templateSku( skuData ) )
                    : $( this.templateSkuNoCommerce( skuData ) );

                // will hide pricing for items with restrictions
                this.priceBreakdownModuleView.setPriceRestrictions( skuData.hasPriceRestrictions );
                this.priceBreakdownModuleView.collection.reset( sku.serializePriceBreaks() );

                // inject kitContents template to DOM placeholder
                $( '#productKitContents' ).html( this.templateskuItemDetails( skuData ) );

                this.render( priceModuleTmpl );
            }
            else {
                $( '#productKitContents' ).empty();
            }
        }
        else if ( data instanceof Backbone.Collection ) {
            if ( 1 < this.collection.length ) {
                // if more than one item in collection then render as PriceRange view
                const skuData = await this.serializeData();
                return this.render( this.templateSkuList( skuData ) );
            }
            else if ( 1 === this.collection.length ) {
                // todo: preselect only option?
                // console.log( 'is Collection ...with a single item' );
                return this.render( this.templateEmpty( {isEcommerceSite, viewDistributorsButton} ) );
            }
        }
    },

    handleQtyChange: function () {
        var qty = this.getQuantity();

        if ( !isNaN( qty ) && qty !== this.prevQty ) {
            this.prevQty = qty;
            this.priceBreakdownModuleView.collection.trigger( 'update:qty', qty );
        }
    },

    render: function ( tmpl ) {
        const isEcommerceSite = app.context.isEcommerceSite;

        this.$el.html( tmpl || this.templateEmpty( {isEcommerceSite, viewDistributorsButton} ) );

        // append childView
        this.$el.find( '.priceBreakdownsWrapper' ).html( this.priceBreakdownModuleView.$el );

        this.renderQtyInput();

        return this;
    },

    calculateMaxInputQuantityForSku: async sku => calculateMaxInputQuantityForProduct( {
        product: {
            sku: sku?.get( 'id' ),
            maxQuantity: sku?.get( 'maxQuantity' )
        }
    } ),

    serializeData: async function ( sku ) {
        var data;

        // Added function to format each kitContents string from skuItemController
        function formatContentsString ( str ) {
            return str.replace( /-{1}/, 'x' );
        }

        if ( sku ) {
            var m = this.collection.get( sku );
            const {maxQuantity, maxQuantityExceeded} = await this.calculateMaxInputQuantityForSku( m );

            // Changed kitContents in the data to be formatted correctly, and added shelfLife
            data = {
                'isLogged': User.isLogged(),
                'isEcommerceSite': app.context.isEcommerceSite,
                'loginButton': loginButton( 'To view price please' ),
                'viewDistributorsButton': viewDistributorsButton,
                'hasPriceRestrictions': m.hasPriceRestrictions(),
                'skuId': m.get( 'id' ).toString().replace( /-$/, '' ),
                'groupId': m.get( 'groupId' ),
                'itemName': stripSpecialCharacters( m.get( 'itemName' ) ),
                'optionName': m.getOptionName(),
                'kitContents': m.get( 'kitContents' ).map( formatContentsString ),
                'shelfLife': m.get( 'shelfLife' ).map( formatContentsString ),
                'options': m.get( 'options' ),
                'currencyCode': m.get( 'currencyCode' ),
                'currencyCountry': m.get( 'currencyCountry' ),
                'customerPrice': (m.get( 'customerPrice' ) > 0)
                    ? m.toCurrency( 'customerPrice' )
                    : 'Price Unavailable',
                'salePrice': (m.get( 'salePrice' ) > 0)
                    ? m.toCurrency( 'salePrice' )
                    : 'Price Unavailable',
                // 'priceBreakdown': m.toCurrency( 'priceBreakdown' ),
                'quantityBreaks': m.toCurrency( 'quantityBreaks' ),
                'maxQuantity': maxQuantity,
                'maxQuantityExceeded': maxQuantityExceeded,
                'images': m.get( 'images' ),
                'unitSize': m.get( 'unitSize' ),
                'isOrderable': m.get( 'isOrderable' ),
                'isWebOrderable': m.get( 'isWebOrderable' ),
                'isFormulary': m.get( 'isFormulary' ),
                'isDomestic': upi.env.IS_ENUS,
                'inStock': m.get( 'inStock' ),
                'expectedShipDate': m.get( 'expectedShipDate' ) ?
                    formatDate( m.get( 'expectedShipDate' ), 'longName' ) :
                    null,
                'isNew': m.get( 'isNew' ),
                'isCustomPrintable': m.get( 'isCustomPrintable' ),
                'selected': m.get( 'selected' )
            };
        }
        else {
            data = {
                'isLogged': User.isLogged(),
                'isEcommerceSite': app.context.isEcommerceSite,
                'loginButton': loginButton( 'To view price please' ),
                'viewDistributorsButton': viewDistributorsButton,
                'hasPriceRestrictions': this.collection.hasPriceRestrictions(),
                'productName': stripSpecialCharacters( app.product.get( 'name' ) ),
                'configurationName': this.configuration
                    ? stripSpecialCharacters( this.configuration.get( 'name' ) )
                    : null,
                'priceRange': this.collection.getPriceRange()
            };
        }

        return data;
    },

    handleQuantityBreakChange: function ( priceBreak ) {
        // only handle changes on currently selected priceBreak - :change on previous priceBreak falls through
        // make sure the priceBreak is a valid price
        if ( priceBreak.get( 'selected' ) && priceBreak.get( 'price' ) > 0 ) {
            var sku = this.collection.getSelectedSku();
            this.setPriceToBreakPoint( priceBreak );
            this.toggleDiscountedPrice( priceBreak.get( 'price' ) < sku.get( 'customerPrice' ) );
        }
    },

    setPriceToBreakPoint: function ( priceBreak ) {
        this.$el.find( '#productItemPriceValue' ).text( priceBreak.toCurrency( 'price' ) );
    },

    toggleDiscountedPrice: function ( isDiscounted ) {
        this.$el.find( '#productItemWasPriceValue' ).toggleClass( 'isDiscounted', isDiscounted );
    },

    async renderQtyInput () {
        var sku = this.collection.getSelectedSku();
        const {maxInputQuantity} = await this.calculateMaxInputQuantityForSku( sku );
        const $qtyPlaceholder = $( '#qtyToggle' )[0];

        if ( $qtyPlaceholder ) {
            render(
                <QtyToggle className="pr-2" value={1} max={maxInputQuantity}
                           onChange={() => this.handleQtyChange()}/>,
                $qtyPlaceholder
            );
        }
    },

    resetView: async function () {
        await this.renderQtyInput();
        this.handleQtyChange();
        this.handleChange( this.collection.getSelectedSku() );
    },

    close: function () {
        this.stopListening( this.collection );
        this.stopListening( app.mediator );
        this.$el.off();
        this.$el.remove();
    }

} );

export default PriceModuleView;
